// Builds one CommandPalette entry per gridable voice in the song.
// Each command, when run, opens the GridEditorModal for that voice via
// the supplied openGrid callback. Voices whose pattern can't be gridded
// (raw / polymeter / euclid / etc.) are filtered out so the palette
// only shows commands the user can actually execute.

import type { Command } from '../../components/CommandPalette';
import type { Song } from '../types';
import { drumGridFromMini } from './drumGridFromMini';
import type { GridTarget } from './GridEditorModal';

export function buildGridCommands(
  song: Song | null,
  openGrid: (target: GridTarget) => void,
): Command[] {
  if (!song) return [];
  const out: Command[] = [];
  for (const stmt of song.statements) {
    if (stmt.kind !== 'const') continue;
    const expr = stmt.expr;
    if (expr.kind !== 'voice.s' && expr.kind !== 'voice.note') continue;
    if (expr.pattern.kind !== 'mini') continue;
    const probe = drumGridFromMini(expr.pattern.nodes);
    if (!probe.ok) continue;
    const voiceName = stmt.name;
    out.push({
      id: `grid.edit.${voiceName}`,
      label: `Edit as grid → ${voiceName}`,
      description: `${probe.state.steps}-step grid · ${probe.state.rows.length} row(s)`,
      section: 'Grid editor',
      keywords: ['grid', 'sequencer', 'drum', 'step', voiceName],
      run: () => openGrid({ voiceId: expr.id, voiceName }),
    });
  }
  return out;
}
